import scroll0 from "./images/scroll/circle/scroll0.png";
import scroll1 from "./images/scroll/circle/scroll1.png";
import scroll2 from "./images/scroll/circle/scroll2.png";
import scroll3 from "./images/scroll/circle/scroll3.png";
import scroll5 from "./images/scroll/circle/scroll5.png";
import scroll6 from "./images/scroll/circle/scroll6.png";
import scroll7 from "./images/scroll/circle/scroll7.png";
import scroll8 from "./images/scroll/circle/scroll8.png";
import scroll9 from "./images/scroll/circle/scroll9.png";
import scroll10 from "./images/scroll/circle/scroll10.png";

export const nigerianStates = [
  "Abia",
  "Adamawa",
  "Akwa Ibom",
  "Anambra",
  "Bauchi",
  "Bayelsa",
  "Benue",
  "Borno",
  "Cross River",
  "Delta",
  "Ebonyi",
  "Edo",
  "Ekiti",
  "Enugu",
  "Gombe",
  "Imo",
  "Jigawa",
  "Kaduna",
  "Kano",
  "Katsina",
  "Kebbi",
  "Kogi",
  "Kwara",
  "Nasarawa",
  "Niger",
  "Ogun",
  "Ondo",
  "Osun",
  "Oyo",
  "Plateau",
  "Rivers",
  "Sokoto",
  "Taraba",
  "Yobe",
  "Zamfara",
];

export const category_list = [
  {
    category_id: "C0",
    category: "ReUp Vault",
    category_slug: "Vault",
    category_image: scroll0,
  },
  {
    category_id: "C1",
    category: "Fresh Farm Produce",
    category_slug: "Farm",
    category_image: scroll1,
  },
  {
    category_id: "C2",
    category: "Grains and Staples",
    category_slug: "Grains",
    category_image: scroll2,
  },
  {
    category_id: "C3",
    category: "Poultry and Meat",
    category_slug: "Poultry",
    category_image: scroll3,
  },
  {
    category_id: "C5",
    category: "Dairy and Eggs",
    category_slug: "Dairy",
    category_image: scroll5,
  },
  {
    category_id: "C6",
    category: "Beverages",
    category_slug: "Beverages",
    category_image: scroll6,
  },
  {
    category_id: "C7",
    category: "Snacks and Confectionery",
    category_slug: "Snacks",
    category_image: scroll7,
  },
  {
    category_id: "C8",
    category: "Canned and Packaged Foods",
    category_slug: "Pantry",
    category_image: scroll8,
  },
  {
    category_id: "C9",
    category: "Frozen Foods",
    category_slug: "Frozen",
    category_image: scroll9,
  },
  {
    category_id: "C10",
    category: "Condiments and Sauces",
    category_slug: "Sauces",
    category_image: scroll10,
  },
];

export const category_details = [
  {
    category_id: "C1",
    category_code: "FFP",
    category: "Fresh Farm Produce",
    category_slug: "Farm",
  },
  {
    category_id: "C2",
    category_code: "GNS",
    category: "Grains and Staples",
    category_slug: "Grains",
  },
  {
    category_id: "C3",
    category_code: "PLM",
    category: "Poultry and Meat",
    category_slug: "Poultry",
  },
  {
    category_id: "C4",
    category_code: "CAT",
    category: "Catfish",
    category_slug: "Catfish",
  },
  {
    category_id: "C5",
    category_code: "DAE",
    category: "Dairy and Eggs",
    category_slug: "Dairy",
  },
  {
    category_id: "C6",
    category_code: "BEV",
    category: "Beverages",
    category_slug: "Beverages",
  },
  {
    category_id: "C7",
    category_code: "SNC",
    category: "Snacks and Confectionery",
    category_slug: "Snacks",
  },
  {
    category_id: "C8",
    category_code: "CPF",
    category: "Canned and Packaged Foods",
    category_slug: "Pantry",
  },
  {
    category_id: "C9",
    category_code: "FRF",
    category: "Frozen Foods",
    category_slug: "Frozen",
  },
  {
    category_id: "C10",
    category_code: "CNS",
    category: "Condiments and Sauces",
    category_slug: "Sauces",
  },
];
